var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"zuiming"}},[_c('section',[_c('zuiminmenu')],1),_c('section',[_c('zuimingcont')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }